import(/* webpackMode: "eager" */ "/home/runner/work/platform/platform/packages/ops-dashboard/src/app/not-found.tsx");
